import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import API_URL from '../config';

function CustomerLogin() {
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_URL}/auth-customer-login`, {
      phone
    });

      if (response.data.success) {
        localStorage.clear();
        localStorage.setItem('userId', response.data.user.id);
        localStorage.setItem('userName', response.data.user.name);
        localStorage.setItem('userPhone', response.data.user.phone);
        localStorage.setItem('userBalance', response.data.user.balance);
        localStorage.setItem('isCustomer', 'true');
        localStorage.setItem('userRole', 'customer');
        navigate('/dashboard');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Customer not found');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="logo">
          <img src="/logo192.png" alt="UMER POULTRY Logo" className="logo-img" />
          <h1>UMER POULTRY</h1>
          <p>Customer Portal</p>
        </div>
        <h2>Login with Phone Number</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="tel"
            placeholder="Phone Number (e.g., 03001234567)"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
          {error && <div className="error">{error}</div>}
          <button type="submit" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        <div className="customer-link">
          <Link to="/">← Staff Login</Link>
        </div>
      </div>
    </div>
  );
}

export default CustomerLogin;